import { useForm } from "react-hook-form";

export default function PromptEdit({
  initialQuestion,
  initialAnswer,
  onSubmit,
}) {
  // Initialize the form with default values
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      question: initialQuestion,
      answer: initialAnswer,
    },
  });

  const submitForm = (data) => {
    console.log("Form submitted:", data);
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(submitForm)} className="space-y-4 p-2">
      <div className="space-y-2">
        <label
          htmlFor="question"
          className="block text-sm font-medium text-gray-700"
        >
          Question
        </label>
        <input
          type="text"
          id="question"
          {...register("question", { required: true })}
          placeholder="Enter question"
          className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
        />
        {errors.question && (
          <p className="text-red-600 text-sm">Question is required</p>
        )}
      </div>
      <div className="space-y-2">
        <label
          htmlFor="answer"
          className="block text-sm font-medium text-gray-700"
        >
          Answer
        </label>
        <textarea
          id="answer"
          {...register("answer")}
          placeholder="Enter answer"
          rows={4}
          className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
        />
      </div>
      <button
        type="submit"
        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      >
        Save
      </button>
    </form>
  );
}
